import { UUID } from '@macs-frontend/core/utils/uuid';
import { AppDateTime } from '@macs-frontend/core/utils/datetime';
import { TeamCostJointCommittee } from '@macs-frontend/features/company-management/team-cost/team-cost.types';
import { ProfessionalStatusesPointHR } from '@macs-frontend/features/human-resources/models/professional-statuses-point-h-r';

export interface ContractTemplate {
  uuid: UUID;
  name: string;
  agencyLogo: string;
  createdAt?: AppDateTime | null;
  updatedAt?: AppDateTime | null;
  jointCommittee: TeamCostJointCommittee | null;
  professionalStatus: ProfessionalStatusesPointHR | null;
  signatureAgency: string;
  translations: Translation[];
  articles: Article[];
  studentAppendixArticles: Article[];
  flexiAppendixArticles: Article[];
  status: ContractTemplateStatuses;
}

export interface Translation {
  uuid: UUID;
  locale: ContractTemplateLocales;
  headerHeight: number;
  footerHeight: number;
  contractTitle: string | null;
  contractId: string | null;
  representationOpening: string | null;
  representationTitleAgency: string | null;
  representationTitleEmployee: string | null;
  representationDetailsAgency: string | null;
  representationDetailsEmployee: string | null;
  contractIntroduction: string | null;
  articleNaming: string | null;
  contractEnding: string | null;
  contractSigningEmployee: string | null;
  contractSigningAgency: string | null;
  agencyDetails: string | null;
  page: string;
  studentAppendixTitle: string | null;
  studentAppendixIntro: string | null;
  studentAppendixArticleNaming: string | null;
  studentAppendixEnding: string | null;
  studentAppendixSigningEmployee: string | null;
  flexiAppendixTitle: string | null;
  flexiAppendixIntro: string | null;
  flexiAppendixArticleNaming: string | null;
  flexiAppendixEnding: string | null;
  flexiAppendixSigningEmployee: string | null;
}

export interface Article {
  uuid: UUID;
  articleIndex: number;
  translations: ArticleTranslation[];
}

export interface ArticleTranslation {
  uuid: UUID | null;
  locale: ContractTemplateLocales;
  content: string;
}

export enum ContractTemplateLocales {
  NL = 'nl',
  FR = 'fr',
  EN = 'en',
}

export const ALL_LOCALES: ContractTemplateLocales[] = [
  ContractTemplateLocales.NL,
  ContractTemplateLocales.FR,
  ContractTemplateLocales.EN,
];

export const LOCALE_LABELS: Record<ContractTemplateLocales, string> = {
  [ContractTemplateLocales.NL]: 'Dutch',
  [ContractTemplateLocales.FR]: 'Français',
  [ContractTemplateLocales.EN]: 'English',
};

export enum ContractTemplateStatuses {
  ALL = 'ALL',
  ACTIVE = 'ACTIVE',
  ARCHIVED = 'ARCHIVED',
}

export enum ContractTemplateSortTypes {
  Name = 'name',
  CreatedAt = 'createdAt',
  Status = 'status',
}
